import React from 'react';
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import validator from "validator";

export class NonProfileInstructorComponent extends React.Component {

    validEmail = false;
    isEmailEmpty = true;
    isFirstNameEmpty = true;
    isLastNameEmpty = true;
    emailAddress = '';
    firstName = '';
    lastName = '';
    phoneNumber = '';
    
    constructor(props) {
        super(props);

        this.state = {
            emailAddress: '',
            emailInputState: 'default',
            emailErrorMessage: 'Instructor email is required',
            firstName: '',
            firstNameInputState: 'default',
            firstNameErrorMessage: 'Instructor first name is required',
            lastName: '',
            lastNameInputState: 'default',
            lastNameErrorMessage: 'Instructor last name is required',
            phoneNumber: ''
        };
    }

    onNewInstructorComponentFocusOut = (event) => {
        const { currentTarget, relatedTarget } = event;

        if (!this.focusInCurrentTarget({ relatedTarget, currentTarget })) {
            this.setErrorState();
        }
    };

    setErrorState = () => {
        if(this.isEmailEmpty){
            this.setState({
                emailInputState: 'error'
            });
        }
        if(this.isFirstNameEmpty){
            this.setState({
                firstNameInputState: 'error'
            });
        }
        if(this.isLastNameEmpty){
            this.setState({
                lastNameInputState: 'error'
            });
        }
    };

    focusInCurrentTarget = ({ relatedTarget, currentTarget }) => {
        if (relatedTarget === null) {
            return false;
        }

        let node = relatedTarget.parentNode;
        while (node !== null) {
            if (node === currentTarget) { return true; }
            node = node.parentNode;
        }
        return false;
    };

    handleInstructorEmail = e => {
        const MAX_LENGTH = 40;
        const inputLength = e.target.value.length;
        if (inputLength <= MAX_LENGTH) {
            this.emailAddress = e.target.value;
            this.validateInstructorEmail(e.target.value);
            this.setState({
                emailAddress: e.target.value,
            });
        }
        this.enableSubmit();
    };

    handleInstructorFname = e => {
        const MAX_LENGTH = 40;
        const inputLength = e.target.value.length;
        if (inputLength <= MAX_LENGTH) {
            this.firstName = e.target.value;
            this.validateInsFname(e.target.value);
            this.setState({
                firstName: e.target.value,
            });
        }
        this.enableSubmit();
    };

    handleInstructorLname = e => {
        const MAX_LENGTH = 40;
        const inputLength = e.target.value.length;
        if (inputLength <= MAX_LENGTH) {
            this.lastName = e.target.value;
            this.validateInsLname(e.target.value);
            this.setState({
                lastName: e.target.value,
            });
        }
        this.enableSubmit();
    };

    handleInstructorPhone = e => {
        const MAX_LENGTH = 10;
        const inputLength = e.target.value.length;
        if (inputLength <= MAX_LENGTH) {
            this.phoneNumber = e.target.value;
            this.setState({
                phoneNumber: e.target.value,
            });
        }
        this.enableSubmit();
    };

    validateInstructorEmail = value => {
        this.isEmailEmpty = validator.isEmpty(value) ;
        this.validEmail = validator.isEmail(value);

        this.setState({
            emailInputState: this.isEmailEmpty ? 'error' : this.validEmail ? 'default' : 'error',
            emailErrorMessage: this.isEmailEmpty ? 'Instructor email is required' : this.validEmail ? null : 'Please enter a valid email'
        });
    };

    validateInsFname = value => {
        this.isFirstNameEmpty = validator.isEmpty(value) ;
        this.setState({
            firstNameInputState: this.isFirstNameEmpty ? 'error' : 'default',
            firstNameErrorMessage: this.isFirstNameEmpty ? 'Instructor first name is required' : null
        });
    };

    validateInsLname = value => {
        this.isLastNameEmpty = validator.isEmpty(value) ;
        this.setState({
            lastNameInputState: this.isLastNameEmpty ? 'error' : 'default',
            lastNameErrorMessage: this.isLastNameEmpty ? 'Instructor last name is required' : null
        });
    };

    enableSubmit = () => {
        const saveInstructorObj = {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.emailAddress,
            phone: this.phoneNumber
        };

        if(this.isEmailEmpty || this.isFirstNameEmpty || this.isLastNameEmpty || !this.validEmail){
            const valueObj = {
                state : false,
                saveInstructorObj: saveInstructorObj
            };
            this.props.changeInstructorData(valueObj,'add-profile');
        }else{
            const valueObj = {
                state : true,
                saveInstructorObj: saveInstructorObj
            };
            this.props.changeInstructorData(valueObj,'add-profile');
        }

    };

    render() {
        return (
            <div className="inst-table-wrapper" onBlur={this.onNewInstructorComponentFocusOut}>
                <div className="row">
                    <TextInput id="emailAddress"
                        labelText="New Instructor Email Address"
                        fancy={false}
                        changeHandler={this.handleInstructorEmail}
                        inputState={this.state.emailInputState}
                        errorMessage={this.state.emailErrorMessage}
                        value={this.state.emailAddress}
                    />
                </div>
                <div className="row">
                    <TextInput id="firstName"
                        labelText="New Instructor First Name"
                        fancy={false}
                        changeHandler={this.handleInstructorFname}
                        inputState={this.state.firstNameInputState}
                        errorMessage={this.state.firstNameErrorMessage}
                        value={this.state.firstName}
                    />
                </div>
                <div className="row">
                    <TextInput id="lastName"
                        labelText="New Instructor Last Name"
                        fancy={false}
                        changeHandler={this.handleInstructorLname}
                        inputState={this.state.lastNameInputState}
                        errorMessage={this.state.lastNameErrorMessage}
                        value={this.state.lastName}
                    />
                </div>
                <div className="row">
                    <TextInput id="phoneNumber"
                        labelText="New Instructor Phone (Optional)"
                        fancy={false}
                        changeHandler={this.handleInstructorPhone}
                        value={this.state.phoneNumber}
                    />
                </div>
            </div>
        )
        ;
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/NonProfileInstructorComponent.js